export const CustomerTypes = ["Organization", "Individual"] as const;
export type CustomerType = (typeof CustomerTypes)[number];
